<template>
  <section class="hero-fournisseurs container-fluid px-0">
    <div class="row g-0 flex-lg-row flex-column">
      <!-- Col gauche : à qui on s’adresse (fond vert) -->
      <div
        class="col-12 col-lg-6 px-5 py-5 d-flex align-items-center hero-left"
      >
        <div class="content">
          <p class="badge">ESPACE FOURNISSEURS</p>
          <h1 class="title">
            Vous êtes fournisseur<br />
            pour les pros du <span class="highlight">BTP&nbsp;?</span>
          </h1>
          <p class="description">
            Dépôts matériaux, négoces, enseignes de bricolage, magasins de
            menuiserie, carrelage, sanitaire ou aménagement extérieur&nbsp;: si
            vous livrez des clients professionnels, Livratos est pensé pour
            votre activité.
          </p>
          <p class="description">
            La plateforme devient votre relais logistique pour
            <strong>envoyer des livraisons directement sur chantier</strong>,
            sans immobiliser vos équipes ni gérer vous-même une flotte de
            véhicules.
          </p>
        </div>
      </div>

      <!-- Col droite : pourquoi utiliser Livratos (fond noir) -->
      <div
        class="col-12 col-lg-6 px-5 py-5 d-flex align-items-center hero-right"
      >
        <div class="content">
          <h2 class="subtitle">
            Pourquoi utiliser <span class="accent">Livratos</span>&nbsp;?
          </h2>
          <p class="description">
            Livratos connecte votre dépôt à un réseau de
            <strong>livreurs indépendants</strong>
            adaptés à chaque commande, tout en vous laissant le contrôle sur
            l’image et la qualité de service.
          </p>

          <ul class="hero-benefits">
            <li>
              <strong>Plus de rotations</strong> au comptoir&nbsp;: vos équipes
              préparent, un <strong>livreur</strong> prend le relais pour la
              <strong>livraison</strong>.
            </li>
            <li>
              <strong>Moins d’attente</strong> pour vos clients pros, qui
              reçoivent directement sur <strong>chantier</strong> au bon
              créneau.
            </li>
            <li>
              <strong>Pas de flotte à gérer</strong>&nbsp;: véhicules,
              assurances et chauffeurs sont déjà dans l’écosystème Livratos.
            </li>
            <li>
              <strong>Suivi des courses</strong> et des
              <strong>livraisons</strong> pour une traçabilité claire en cas de
              litige ou de question client.
            </li>
          </ul>

          <div class="d-flex gap-3 mt-4 flex-wrap">
            <a href="https://www.livratos.app" class="btn btn-cta fw-semibold">
              Créer mon compte fournisseur
            </a>
            <a
              href="/contact"
              class="btn btn-link text-decoration-none fw-medium link-more"
            >
              Parler à l’équipe Livratos
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.hero-fournisseurs {
  margin-top: 72px; // navbar fixe
  margin-bottom: 72px;

  .content {
    max-width: 540px;
    margin: auto;
  }

  /* === Mobile / par défaut : blocs empilés vert puis noir === */
  .hero-left {
    background-color: $color-primary;
    color: #ffffff;

    .badge {
      display: inline-block;
      background-color: rgba(#000000, 0.16);
      color: #000;
      font-size: 0.7rem;
      font-weight: 600;
      padding: 0.3rem 0.9rem;
      border-radius: 50px;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    .title {
      font-size: 2.2rem;
      font-weight: 700;
      color: #ffffff;
      margin-top: 1rem;
      line-height: 1.3;

      .highlight {
        color: #000000;
      }

      @media (min-width: 768px) {
        font-size: 3rem;
      }
    }

    .description {
      color: rgba(#ffffff, 0.92);
      margin-top: 1.1rem;
      font-size: 1rem;
      line-height: 1.7;

      @media (min-width: 768px) {
        font-size: 1.05rem;
      }
    }
  }

  .hero-right {
    background-color: #000000;
    color: #ffffff;

    .subtitle {
      font-size: 1.7rem;
      font-weight: 700;
      color: #ffffff;
      margin-bottom: 0.75rem;

      .accent {
        color: $color-primary;
      }

      @media (min-width: 768px) {
        font-size: 2rem;
      }
    }

    .description {
      color: rgba(#ffffff, 0.9);
      margin-top: 0.8rem;
      font-size: 1rem;
      line-height: 1.7;

      @media (min-width: 768px) {
        font-size: 1.05rem;
      }
    }

    .hero-benefits {
      margin-top: 1rem;
      padding-left: 0;
      list-style: none;

      li {
        position: relative;
        padding-left: 1.3rem;
        margin-bottom: 0.45rem;
        font-size: 0.95rem;
        color: rgba(#ffffff, 0.9);

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.55em;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: $color-primary;
          box-shadow: 0 0 0 2px rgba($color-primary, 0.25);
          transform: translateY(-50%);
        }
      }
    }

    .btn-cta {
      background-color: $color-primary;
      border: 1px solid $color-primary;
      color: #000;
      padding: 0.65rem 1.6rem;
      border-radius: 6px;
      font-size: 0.95rem;
      text-transform: uppercase;

      &:hover {
        background-color: darken($color-primary, 8%);
        border-color: darken($color-primary, 8%);
        color: #000;
      }
    }

    .link-more {
      color: #ffffff;
      font-size: 0.95rem;

      &:hover {
        color: $color-primary;
        text-decoration: underline;
      }
    }
  }

  /* === Desktop : vraie séparation diagonale entre vert / noir === */
  @media (min-width: 992px) {
    position: relative;
    overflow: hidden;
    background-color: $color-primary; // toute la largeur verte de base

    // on enlève les fonds plats pour laisser agir le fond global + le panneau noir
    .hero-left {
      background-color: transparent;
    }

    .hero-right {
      background-color: transparent;
    }

    /* Panneau noir incliné côté droit */
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: -10%; // dépasse légèrement pour bien couvrir
      bottom: 0;
      width: 60%;
      background-color: #000000;
      transform: skewX(-10deg); // 👉 diagonale plus marquée
      transform-origin: top right;
      z-index: 0;
    }

    /* on remet le contenu au-dessus du panneau noir */
    .hero-left,
    .hero-right {
      position: relative;
      z-index: 1;
    }
  }
}
</style>
